module.exports = __webpack_public_path__ + "img/stop.3b191f30.svg";